module.exports = __webpack_public_path__ + "img/partner_lp_bnr_02.4f3286f2.jpg";